import { css, cx } from '@emotion/css';
import { Row, Col, Skeleton, Space } from 'antd';
import { useIsMobile } from 'src/hooks';
import { MCard, MTypography } from 'src/lib';
import { ColorConstant, Display, FlexDirection, ScreenBreakpoint, Spacing } from 'src/styles';

import { PortofolioSummaryInfo } from './accountSummary.model';
import SummaryChart from './SummaryChart';
import SummaryInfo from './SummaryInfo';

const titleRowStyle = css`
  ${Spacing.mt32}
  ${Spacing.mb12}
`;

const cardStyle = css`
  ${Spacing.p24}
  @media (max-width: ${ScreenBreakpoint.mobile.min}) {
    .ant-card-body {
      ${Spacing.px4};
    }
  }
  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    width: auto;
    ${Spacing.mx16};
  }
`;

const summaryInfoStyle = css`
  width: 100%;
`;

interface AccountSummaryProps {
  title: string;
  isLoading: boolean;
  accountValue: number;
  portofolio: PortofolioSummaryInfo;
  infoTitle: string;
  onRefresh: () => void;
}

export const AccountSummary = ({
  title,
  isLoading,
  accountValue,
  portofolio,
  infoTitle,
  onRefresh,
}: AccountSummaryProps) => {
  const isMobile = useIsMobile();

  return (
    <Skeleton loading={isLoading}>
      <Row className={titleRowStyle}>
        <MTypography variant='h4' weight='semibold' color={ColorConstant.BRAND6}>
          {title}
        </MTypography>
      </Row>
      <Row justify='center'>
        <Col span={24}>
          <MCard className={cardStyle}>
            <Row>
              <Col span={24} className={cx(Display.flex, isMobile ? FlexDirection.column : FlexDirection.row)}>
                <Space.Compact direction={isMobile ? 'vertical' : 'horizontal'} block>
                  <SummaryChart accountValue={accountValue} portofolio={portofolio} />
                  <SummaryInfo
                    infoTitle={infoTitle}
                    portofolio={portofolio}
                    onRefresh={onRefresh}
                    className={summaryInfoStyle}
                  />
                </Space.Compact>
              </Col>
            </Row>
          </MCard>
        </Col>
      </Row>
    </Skeleton>
  );
};
